import GlobalConfig from '../v-x-e-table/src/conf';
export function getLog(message, params) {
    return "[vxe-table v".concat("4.5.21", "] ").concat(GlobalConfig.i18n(message, params));
}
function outLog(type) {
    return function (message, params) {
        var msg = getLog(message, params);
        console[type](msg);
        return msg;
    };
}
export var warnLog = outLog('warn');
export var errLog = outLog('error');
